import { SaveService } from 'src/app/services/save.service';
import { DetailsService } from './../../../../services/details.service';
import { CharacteristicService } from 'src/app/services/characteristic.service';
//#region imports
import { startWith, map } from 'rxjs/operators';
import { Globals } from './../../../../services/globals';
import { SignatureService } from 'src/app/services/signature.service';
import { SaveAddressModel, SaveCriteriaModel } from './../../model/signature.model';
import { FormGroup, FormControl, Validators,AbstractControl, FormBuilder, ValidationErrors } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material';
import { ValidatorService } from 'angular-iban';
import { SectionService } from 'src/app/services/section.service';
import { AppConstants } from 'src/app/app.constants';
import * as moment from 'moment';
import { ContactDetails } from 'src/app/shared/model/save.model';
import { validatePhoneNumber } from 'src/app/shared/utils/phonenumber.validator';
//#endregion

@Component({
  selector: 'app-signature-question3',
  templateUrl: './signature-question3.component.html',
  styleUrls: ['./signature-question3.component.css']
})
export class SignatureQuestion3Component implements OnInit {
  //#region variables
  contactDetails: ContactDetails;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  street: string;
  errors: string[] = [];
  direction: string;
  box: string;
  msCivility = true;
  mrCivility = false;
  signForm: FormGroup;
  postalForm: FormGroup;
  signatureSaveList: SaveAddressModel;
  signatureData: any;
  location: any;
  code: any;
  newCode: any;
  newLocation: any;
  selectedCountry: any;
  invalid = false;
  invalidLocation = false;
  minDate: Date;
  maxDate: Date;
  date: any;
  country: any = [];
  postalLocality = true;
  selectedFilteredCountry: any;
  emailpattern: any;
  clientIdOrSimulationTokenPresent = false;
  dobdisable = false;
  //#endregion

  //#region methods
  constructor(
    private formBuilder: FormBuilder, private signatureService: SignatureService,
    private saveService: SaveService,
    private globals: Globals, private sectionService: SectionService, private characteristicService: CharacteristicService) {
    this.signatureSaveList = this.signatureService.getSaveAddress1(); // new SaveAddressModel();
    const currentYear = new Date().getFullYear();
    this.minDate = new Date(1901, 0, 1);
    this.maxDate = new Date(currentYear - 18, new Date().getMonth(), new Date().getDate());
  } 

  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    // this.events.push(`${type}: ${event.value}`);
    const dateVal = moment(new Date(event.value)).format('YYYY-MM-DD');
    this.postalForm.get('birthDate').patchValue(new Date(event.value));
    this.mapAnswer('Taker_BirthDate', dateVal);
  }

  ngOnInit() {
    this.postalForm = new FormGroup({
      gender: new FormControl('', Validators.required),
      firstName: new FormControl(null, [Validators.required, Validators.minLength(2)]),
      lastName: new FormControl(null, [Validators.required, Validators.minLength(2)]),
      countryName: new FormControl(null, [Validators.required]),
      birthDate: new FormControl(this.date, [Validators.required]),
      
      accountNumber: new FormControl('', ValidatorService.validateIban),
      email: new FormControl('', [Validators.required, Validators.pattern(AppConstants.EmailIdRegexPattern)]),
      phone: new FormControl('', [Validators.required, validatePhoneNumber]),
      code: new FormControl(null, [Validators.required, this.validatepostallocality]),
      cityName: new FormControl(null, [Validators.required]),
      newCode: new FormControl(''),
      newLocation: new FormControl(''),
      street : new FormControl('', [Validators.required]),
      direction : new FormControl('', [Validators.required]),
    });
    this.sectionService.setCurrentPage('P5-3');
    this.globals.trackPageActivity += ';' + 'P5-3';
    this.signatureService.setShowSignaturePrevious(true);
    this.signatureData = JSON.parse(sessionStorage.getItem('signatureData'));
    this.contactDetails = this.saveService.getContactDetails();
    this.globals.quesWarning = false;
    this.clientIdOrSimulationTokenPresent = this.characteristicService.getClientIdOrSimulationTokenPresent();
    this.setData();    
    this.postalForm.get('accountNumber').valueChanges.subscribe(selectedValue => {
      this.mapAnswer('Taker_Bank_Account_Number', selectedValue);
    });
    this.emailpattern = AppConstants.EmailIdRegexPattern;
    this.postalForm.get('firstName').valueChanges.subscribe(val => {
      this.modelChanged('Taker_Name', val);
    });
    this.postalForm.get('lastName').valueChanges.subscribe(val => {
      this.modelChanged('Taker_Last_Name', val);
    });
    this.postalForm.get('email').valueChanges.subscribe(val => {
      this.modelChanged('Simulation_mail_Contact', val);
    });

    this.postalForm.get('phone').valueChanges.subscribe(val => {
      this.phone = val;
      this.modelChanged('Simulation_Phone_Contact', val);
    });
    
    this.postalForm.get('code').valueChanges.subscribe(val => {
      this.code = val;
      this.modelChanged('Taker_Address_Post_Code', val);
    });
    this.postalForm.get('cityName').valueChanges.subscribe(val => {
      this.selectedCountry = val;
      this.onSelectionChange('Taker_Address_Place', val);
    });
    this.postalForm.get('newCode').valueChanges.subscribe(val => {
      this.invalid = false;
      this.invalidLocation = false;
      const saveAddress = this.signatureService.getSaveAddress1();
      const Taker_Address_Country_field = saveAddress.Taker_Address_Country;
      if (Taker_Address_Country_field !== 'BELGIQUE' && Taker_Address_Country_field !== 'BELGIE' && Taker_Address_Country_field !== 'BELGIEN')
      {this.modelChanged('New_Taker_Address_Post_Code', val);}
    });
    this.postalForm.get('newLocation').valueChanges.subscribe(val => {
      const saveAddress = this.signatureService.getSaveAddress1();
      const Taker_Address_Country_field = saveAddress.Taker_Address_Country;
      if (Taker_Address_Country_field !== 'BELGIQUE' && Taker_Address_Country_field !== 'BELGIE' && Taker_Address_Country_field !== 'BELGIEN')
      {
          this.modelChanged('New_Taker_Address_Place', val);
      }
      // this.postalForm.get('cityName').patchValue(val);
    });
  this.postalForm.get('street').valueChanges.subscribe(val => {
      this.modelChanged('Taker_Address_Street', val);
    });
    this.postalForm.get('countryName').valueChanges.subscribe(val => {
      this.countryChanged('Taker_Address_Country', val);
    if (val){
      if (val !== 'BELGIQUE' && val !== 'BELGIE' && val !== 'BELGIEN')
      {
        
        this.postalForm.get('newCode').setValidators(Validators.required);
        this.postalForm.get('newLocation').setValidators(Validators.required);
        // this.postalForm.controls.cityName.setErrors({ incorrect: false });
        this.removeValidators(this.postalForm,['code','cityName']);
      }
      else
      {
        this.postalForm.get('code').setValidators([Validators.required,this.validatepostallocality, Validators.minLength(4), Validators.maxLength(4)]);
        this.postalForm.get('cityName').setValidators(Validators.required);
        this.removeValidators(this.postalForm,['newCode','newLocation']);
      }
    }    
    });
    this.postalForm.get('direction').valueChanges.subscribe(val => {
      this.modelChanged('Taker_Address_Street_Number', val);
    });
    this.postalForm.valueChanges.subscribe(selVal => {
      // console.log("form value changed");
      // console.log(selVal);
      if (this.postalForm.valid){
        this.signatureService.signaturepage3validate = true;
      }
      else{
        this.signatureService.signaturepage3validate = false;
        this.errors = [];  
        // this.generateErrorMessages(this.postalForm); commented this block to dubug for errors in future so pls dnt delete.
        // console.log('Final Error Log: ' + this.errors);
      }
      // console.log('signaturevalid status' + this.signatureService.signaturepage3validate);
    });
    if (this.clientIdOrSimulationTokenPresent){
      this.postalForm.get('firstName').disable();
      this.postalForm.get('lastName').disable();

    }
    const saveCriteria: SaveCriteriaModel = {
      Criteria_sinistrality: false,
      Criteria_cancellation_other_company: false,
      Criteria_never_insured_property: false,
      Criteria_bankrupty: false,
      Taker_specific_requirement: '',
      Sales_office: null,
      ID_IMD: null,
      Longitude: null,
      Lattidude: null,
      FNICEFile: null,
      NoClient: null,
      OfferDocPath: null
    };
    this.signatureService.setSaveCriteria(saveCriteria);
  }

  removeValidators(form: FormGroup, keys) {
    for (const index in keys) {
        form.get(keys[index]).clearValidators();
        form.get(keys[index]).updateValueAndValidity();
    }
}
  get f() { return this.postalForm.controls; }

  setGender(value) {
    this.mapAnswer('Taker_Civility', value);
  }


  validatepostallocality = (control: FormControl): ValidationErrors => {
    const locationsdata = this.globals.locationData.Locations;
    if (control.value === "") { return null; }
    if(this.globals != undefined) {
    const location = this.globals.locationData.Locations.filter(obj => obj.PostalCode === control.value);
    return location.length > 0 ? null : { postalCode: true };
    } else {
      return null;
    }
    // return validPostalCode ? null : { postalCode: true };
  }

  setCountry() {
    this.country = [];
    this.globals.filteredCountry = [];
    if (this.globals.languagecode === 'FR') {
      this.globals.countryData.Countries.forEach(obj => this.globals.filteredCountry.push(obj.NomPaysFR));
      this.globals.filteredCountry.sort();
      if (this.signatureData){
      this.selectedFilteredCountry = 
      this.signatureData.Taker_Address_Country != null && this.signatureData.Taker_Address_Country != '' 
      && this.globals.filteredCountry.findIndex(option => option.toLowerCase() == this.signatureData.Taker_Address_Country.toLowerCase()) !=-1 ?
        this.signatureData.Taker_Address_Country : 'BELGIQUE';
      }
      this.postalLocality = this.selectedFilteredCountry === 'BELGIQUE' ? true : false;
      this.globals.selectedCountry = this.selectedFilteredCountry;

    } else if (this.globals.languagecode === 'NL') {
      this.globals.countryData.Countries.forEach(obj => this.globals.filteredCountry.push(obj.NomPaysNL));
      this.globals.filteredCountry.sort();
      if (this.signatureData){
      this.selectedFilteredCountry = this.signatureData.Taker_Address_Country != null && this.signatureData.Taker_Address_Country !== ''
        && this.globals.filteredCountry.findIndex(option => option.toLowerCase() === this.signatureData.Taker_Address_Country.toLowerCase()) !== -1 ?
        this.signatureData.Taker_Address_Country : 'BELGIE';
      }
      this.postalLocality = this.selectedFilteredCountry === 'BELGIE' ? true : false;
      this.globals.selectedCountry = this.selectedFilteredCountry;
    } else {
      this.globals.countryData.Countries.forEach(obj => this.globals.filteredCountry.push(obj.NomPaysEN));
      this.globals.filteredCountry.sort();
      this.selectedFilteredCountry = this.signatureData.Taker_Address_Country != null && this.signatureData.Taker_Address_Country !== ''
        && this.globals.
        filteredCountry.indexOf(option => option.toLowerCase() === this.signatureData.Taker_Address_Country.toLowerCase()) !== -1 ?
        this.signatureData.Taker_Address_Country : 'BELGIEN';
      this.postalLocality = this.selectedFilteredCountry === 'BELGIEN' ? true : false;
      this.globals.selectedCountry = this.selectedFilteredCountry;
    }
    this.postalForm.patchValue({
      countryName: this.selectedFilteredCountry
    });
    const saveAddress = this.signatureService.getSaveAddress1();
    saveAddress.Taker_Address_Country = this.selectedFilteredCountry;
    this.signatureService.setSaveAddress1(saveAddress);
  }

  setLocation() {
    this.location = [];
    // const jsonData = sessionStorage.getItem('jsonData');
    // const data = JSON.parse(jsonData);
    let firstAnswer = this.signatureData.Copy_Address ?
      this.signatureData.Property_Address_Post_Code : this.signatureData.Taker_Address_Post_Code;
      if (this.signatureData.Copy_Address == false && this.clientIdOrSimulationTokenPresent == true){
        if(this.contactDetails.PostalCode !== '' && this.contactDetails.PostalCode !== undefined){
        firstAnswer = this.contactDetails.PostalCode;}
        else{firstAnswer = '';}
      }
    this.code = firstAnswer !== '' ? firstAnswer : '';
    this.postalForm.patchValue({code: this.code});
    this.globals.postalCode = this.code;
    if (this.globals.languagecode === 'FR' && this.code !== 'undefined'
      && this.code != null && this.code !== '') {
      this.globals.locationData.Locations.filter(obj => obj.PostalCode === this.code).forEach(obj => this.location.push(obj.LibelleFR));
    } else if (this.globals.languagecode === 'NL' && this.code !== 'undefined'
      && this.code != null && this.code !== '') {
      this.globals.locationData.Locations.filter(obj => obj.PostalCode === this.code).forEach(obj => this.location.push(obj.LibelleNL));
    } else if (this.globals.languagecode === 'EN' && this.code !== 'undefined'
      && this.code != null && this.code !== '') {
      this.globals.locationData.Locations.filter(obj => obj.PostalCode === this.code).forEach(obj => this.location.push(obj.LibelleNL));
    }
    const secondAnswer = this.signatureData.Copy_Address ?
      this.signatureData.Property_Address_Place : this.signatureData.Taker_Address_Place;
    if (secondAnswer != null) {
      this.postalForm.patchValue({
        cityName: this.location.find(obj => obj === secondAnswer)
      });
      this.selectedCountry = this.location.find(obj => obj === secondAnswer);
    }
    this.globals.filteredLocality = this.cityName.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
    this.globals.filteredLocation = this.location;
    this.signatureData.Taker_Address_Post_Code = firstAnswer;
    this.signatureData.Taker_Address_Place = secondAnswer;
    const saveAddress = this.signatureService.getSaveAddress1();
    saveAddress.Taker_Address_Post_Code = firstAnswer;
    saveAddress.Taker_Address_Place = secondAnswer;
    this.signatureService.setSaveAddress1(saveAddress);
    this.signatureService.setPropertyPostalCode(this.signatureData.Property_Address_Post_Code);
    this.signatureService.setPropertyPostalCodePlace(this.signatureData.Property_Address_Place);
  }

  setData() {
    this.setCountry();
    const data = JSON.parse(sessionStorage.getItem('jsonData'));
    const saveAddress = this.signatureService.getSaveAddress1();
    const section = data.Sections.find(obj => obj.SectionKey === 'S2.1');
    const sectionKey = section != null ? 'S2.1' : 'S2.2';
    if (this.signatureData.Taker_Name === '' || this.signatureData.Taker_Name === null) {
      if (sectionKey === 'S2.1') {
        const firstAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.1').
          QuestionGroup.find(obj => obj.GroupKey === 'G11').
          Questions.find(obj => obj.QuestionKey === 'House_Simulation_User_Name_Question').Answers;
        this.firstName = firstAnswer != null ? firstAnswer[0].AnswerText : '';
        const secondAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.1').
          QuestionGroup.find(obj => obj.GroupKey === 'G11').
          Questions.find(obj => obj.QuestionKey === 'House_Simulation_User_Last_Name_Question').Answers;
        this.lastName = secondAnswer != null ? secondAnswer[0].AnswerText : '';
        const thirdAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.1').
          QuestionGroup.find(obj => obj.GroupKey === 'G11').
          Questions.find(obj => obj.QuestionKey === 'House_Simulation_Mail_Contact_Question').Answers;
        this.email = thirdAnswer != null ? thirdAnswer[0].AnswerText : '';
        const fourthAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.1').
          QuestionGroup.find(obj => obj.GroupKey === 'G11').
          Questions.find(obj => obj.QuestionKey === 'House_Simulation_phone_Contact_Question').Answers;
        this.phone = fourthAnswer != null ? fourthAnswer[0].AnswerText : '';
        this.postalForm.get('phone').patchValue(this.phone);
        this.signatureData.Taker_Name = this.firstName;
        this.signatureData.Taker_Last_Name = this.lastName;
        this.signatureData.Simulation_Phone_Contact = this.phone;
        this.signatureData.Simulation_mail_Contact = this.email;
        saveAddress.Taker_Name = this.firstName;
        saveAddress.Taker_Last_Name = this.lastName;
        saveAddress.Simulation_Phone_Contact = this.phone;
        saveAddress.Simulation_mail_Contact = this.email;
        if (this.contactDetails !== undefined && this.contactDetails !== null) {
          // this.contactDetails.DateofBirth = '2001-05-16 20:00:00';
          if (this.contactDetails.DateofBirth !== undefined && this.contactDetails.DateofBirth !== null){
            this.signatureData.Taker_BirthDate =  moment(new Date(this.contactDetails.DateofBirth)).format('YYYY-MM-DD');
            saveAddress.Taker_BirthDate = moment(new Date(this.contactDetails.DateofBirth)).format('YYYY-MM-DD');
            this.date = moment(new Date(this.contactDetails.DateofBirth)).format('YYYY-MM-DD'); //this.contactDetails.DateofBirth;  moment(new Date('2001-05-16 20:00:00')).format('YYYY-MM-DD'); //this.contactDetails.DateofBirth;
            this.postalForm.get('birthDate').patchValue(new Date(this.date));
            this.dobdisable = true;
          }
        }
      } else {
        const firstAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.2').
          QuestionGroup.find(obj => obj.GroupKey === 'G17').
          Questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_User_Name_Question').Answers;
        this.firstName = firstAnswer != null ? firstAnswer[0].AnswerText : '';
        const secondAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.2').
          QuestionGroup.find(obj => obj.GroupKey === 'G17').
          Questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_User_Last_Name_Question').Answers;
        this.lastName = secondAnswer != null ? secondAnswer[0].AnswerText : '';
        const thirdAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.2').
          QuestionGroup.find(obj => obj.GroupKey === 'G17').
          Questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_Mail_Contact_Question').Answers;
        this.email = thirdAnswer != null ? thirdAnswer[0].AnswerText : '';
        const fourthAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.2').
          QuestionGroup.find(obj => obj.GroupKey === 'G17').
          Questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_phone_Contact_Question').Answers;
        this.phone = fourthAnswer != null ? fourthAnswer[0].AnswerText : '';
        this.postalForm.get('phone').patchValue(this.phone);
        this.signatureData.Taker_Name = this.firstName;
        this.signatureData.Taker_Last_Name = this.lastName;
        this.signatureData.Simulation_Phone_Contact = this.phone;
        this.signatureData.Simulation_mail_Contact = this.email;
        if (this.contactDetails !== undefined && this.contactDetails !== null){
          // this.contactDetails.DateofBirth = '2001-05-16 20:00:00';
          if (this.contactDetails.DateofBirth !== undefined && this.contactDetails.DateofBirth !== null){
            this.signatureData.Taker_BirthDate =  moment(new Date(this.contactDetails.DateofBirth)).format('YYYY-MM-DD');
            saveAddress.Taker_BirthDate = moment(new Date(this.contactDetails.DateofBirth)).format('YYYY-MM-DD');
            this.date = moment(new Date(this.contactDetails.DateofBirth)).format('YYYY-MM-DD'); //this.contactDetails.DateofBirth;  moment(new Date('2001-05-16 20:00:00')).format('YYYY-MM-DD'); //this.contactDetails.DateofBirth;
            this.postalForm.get('birthDate').patchValue(new Date(this.date));
            this.dobdisable = true;
          }
        }
        saveAddress.Taker_Name = this.firstName;
        saveAddress.Taker_Last_Name = this.lastName;
        saveAddress.Simulation_Phone_Contact = this.phone;
        saveAddress.Simulation_mail_Contact = this.email;
      }
    } else {
      this.firstName = this.signatureData.Taker_Name;
      this.lastName = this.signatureData.Taker_Last_Name;
      this.phone = this.signatureData.Simulation_Phone_Contact;
      this.postalForm.get('phone').patchValue(this.phone);
      this.email = this.signatureData.Simulation_mail_Contact;
      this.date = this.signatureData.Taker_BirthDate;
      this.postalForm.get('birthDate').patchValue(new Date(this.date));
      if (this.date !== undefined && this.date !== null){
        this.dobdisable = true;
      }
      this.postalForm.get('gender').patchValue(this.signatureData.Taker_Civility);
      this.postalForm.get('countryName').patchValue(this.signatureData.Taker_Address_Country);
      this.newCode = this.signatureData.Taker_Address_Post_Code;
      this.postalForm.get('newCode').patchValue(this.newCode);
      this.newLocation = this.signatureData.Taker_Address_Place;
      this.postalForm.get('newLocation').patchValue(this.newLocation);
      this.code = this.signatureData.Taker_Address_Post_Code;
      this.postalForm.get('code').patchValue(this.code);
      this.selectedCountry = this.signatureData.Taker_Address_Place;
      this.postalForm.get('cityName').patchValue(this.selectedCountry);
      this.postalForm.get('accountNumber').patchValue(this.signatureData.Taker_Bank_Account_Number);
    }
    if (this.signatureData.Copy_Address) {
      this.setLocation();
      this.street = this.signatureData.Property_Address_Street;
      this.direction = this.signatureData.Property_Address_Street_Number;
      this.box = this.signatureData.Property_Address_Box;
    } else {
      this.setLocation();
      if (this.clientIdOrSimulationTokenPresent){
        if(this.contactDetails !== undefined && this.contactDetails !== null)
        {
          this.street = this.contactDetails.StreetName;
          this.direction = this.contactDetails.StreetNumber;
          this.box = this.contactDetails.BoxNumber;
        }
        else{
          this.street = this.signatureData.Taker_Address_Street ;
          this.direction = this.signatureData.Taker_Address_Street_Number;
          this.box = this.signatureData.Taker_Address_Box;
          }
      }
      else {
        this.street = this.signatureData.Taker_Address_Street ;
        this.direction = this.signatureData.Taker_Address_Street_Number;
        this.box = this.signatureData.Taker_Address_Box;
      }
    }
    this.signatureData.Taker_Address_Street = this.street;
    saveAddress.Taker_Address_Street = this.street;
    this.direction = this.signatureData.Taker_Address_Street_Number = this.direction;
    this.box = this.signatureData.Taker_Address_Box = this.box;
    saveAddress.Taker_Address_Street_Number = this.direction;
    saveAddress.Taker_Address_Box = this.box;
    this.signatureService.setSaveAddress1(saveAddress);
    sessionStorage.setItem('signatureData', JSON.stringify(this.signatureData));
    this.signForm = this.formBuilder.group({
      honor: ['', [Validators.required]]
    });
  }

  get cityName() {
    return this.postalForm.get('cityName');
  }

  get gender() {
    return this.postalForm.get('gender');
  }

  get countryName() {
    return this.postalForm.get('countryName');
  }

  get accountNumber() {
    return this.postalForm.get('accountNumber');
  }

  get birthDate() {
    return this.postalForm.get('birthDate');
  }

  private _filter(value: string): string[] {
    const filterValue = '' ; //value != null ? value.toLowerCase() : value;
    return this.location.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }

  modelChanged(choice, enteredValue) {
    if (choice === 'New_Taker_Address_Post_Code') {
      this.signatureService.setPropertyPostalCode(enteredValue);
      this.mapAnswer('Taker_Address_Post_Code', enteredValue);
      // this.postalForm.get('code').patchValue(enteredValue);
    } else if (choice === 'New_Taker_Address_Place') {
      this.signatureService.setPropertyPostalCodePlace(enteredValue);
      this.mapAnswer('Taker_Address_Place', enteredValue);
    }
    if (choice === 'Taker_Address_Post_Code') {
      this.globals.filteredLocation = [];
      this.location = [];
      if (this.code.length === 4) {
        this.cityName.setValue('');
        const location = this.globals.locationData.Locations.filter(obj => obj.PostalCode === this.code);
        this.invalid = location.length > 0 ? false : true;
        if (this.globals.languagecode === 'FR' && this.code != null && this.code !== '' && this.code.length === 4 && location != null) {
          location.forEach(obj => this.location.push(obj.LibelleFR));
        } else if (this.globals.languagecode === 'NL' && this.code != null &&
          this.code !== '' && this.code.length === 4 && location != null) {
          location != null ? location.forEach(obj => this.location.push(obj.LibelleNL)) : '';
        }
        this.selectedCountry = this.location[0];
        this.globals.filteredLocality = this.cityName.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value))
        );
        this.globals.filteredLocation = this.location;
        this.invalidLocation = false;
        this.mapAnswer(choice, enteredValue);
      } else {
        this.selectedCountry = null;
        this.invalid = false;
        this.mapAnswer(choice, enteredValue);
      }
      this.signatureService.setPropertyPostalCode(enteredValue);

      // if (this.signatureService.getSaveAddress1().Taker_Address_Country == "BELGIQUE" || this.signatureService.getSaveAddress1().Taker_Address_Country == "BELGIE" ||
      // this.signatureService.getSaveAddress1().Taker_Address_Country =="BELGIEN")
      // {
      //  var contact =  this.saveService.getContactDetails();
      //  if(enteredValue !== contact.PostalCode)
      //  {
      //    contact.PostalCode = enteredValue;
      //   this.saveService.setContactDetails(contact);
      //   }
      // }
    } else {
      this.mapAnswer(choice, enteredValue);
    }
  }

  countryChanged(choice, selectedValue) {
    if ((selectedValue !== 'BELGIQUE') && (selectedValue !== 'BELGIEN') && (selectedValue !== 'BELGIE')) {
      this.postalLocality = false;
    } else {
      this.postalLocality = true;
    }
    this.mapAnswer('Taker_Address_Country', selectedValue);
    const saveAddress = this.signatureService.getSaveAddress1();
    saveAddress.Taker_Address_Country = selectedValue;
    this.signatureService.setSaveAddress1(saveAddress);
  }

  mapAnswer(selectedChoice, selectedText) {
    const jsonData = sessionStorage.getItem('signatureData');
    const data = JSON.parse(jsonData);
    const saveAddress = this.signatureService.getSaveAddress1();
    switch (selectedChoice) {
      case 'Taker_Name':
        data.Taker_Name = selectedText;
        saveAddress.Taker_Name = selectedText;
        break;
      case 'Taker_Last_Name':
        data.Taker_Last_Name = selectedText;
        saveAddress.Taker_Last_Name = selectedText;
        break;
      case 'Simulation_Phone_Contact':
        data.Simulation_Phone_Contact = selectedText;
        saveAddress.Simulation_Phone_Contact = selectedText;
        break;
      case 'Simulation_mail_Contact':
        data.Simulation_mail_Contact = selectedText;
        saveAddress.Simulation_mail_Contact = selectedText;
        break;
      case 'Taker_Civility':
        data.Taker_Civility = selectedText;
        saveAddress.Taker_Civility = selectedText;
        break;
      case 'Taker_BirthDate':
        data.Taker_BirthDate = selectedText;
        saveAddress.Taker_BirthDate = selectedText;
        break;
      case 'Taker_Address_Country':
        data.Taker_Address_Country = selectedText;
        saveAddress.Taker_Address_Country = selectedText;
        break;
      case 'Taker_Address_Post_Code':
        data.Taker_Address_Post_Code = selectedText;
        data.Taker_Address_Place = this.selectedCountry != null ? this.selectedCountry : data.Taker_Address_Place;
        saveAddress.Taker_Address_Post_Code = selectedText;
        saveAddress.Taker_Address_Place = this.selectedCountry != null ? this.selectedCountry : saveAddress.Taker_Address_Place;
        break;
      case 'Taker_Address_Place':
        // if (selectedText.value !== undefined && selectedText !== null)
        //  { data.Taker_Address_Place = selectedText.value;
        //   saveAddress.Taker_Address_Place = selectedText.value;}
        // else
        // { data.Taker_Address_Place = selectedText;
        //   saveAddress.Taker_Address_Place = selectedText;}
        data.Taker_Address_Place = selectedText;
        saveAddress.Taker_Address_Place = selectedText;
        break;
      case 'Taker_Address_Street':
        data.Taker_Address_Street = selectedText;
        saveAddress.Taker_Address_Street = selectedText;
        break;
      case 'Taker_Address_Street_Number':
        data.Taker_Address_Street_Number = selectedText;
        saveAddress.Taker_Address_Street_Number = selectedText;
        break;
      case 'Taker_Address_Box':
        data.Taker_Address_Box = selectedText;
        saveAddress.Taker_Address_Box = selectedText;
        break;
      case 'Taker_Bank_Account_Number':
        data.Taker_Bank_Account_Number = selectedText;
        saveAddress.Taker_Bank_Account_Number = selectedText;
        break;
    }
    this.signatureService.setSaveAddress1(saveAddress);
    sessionStorage.setItem('signatureData', JSON.stringify(data));
  }

  validateInput(value) {
    const locationValue = value !== undefined ? this.globals.filteredLocation.find(obj => obj === value) : 1;
    if (locationValue == null || locationValue == undefined) {
      this.postalForm.controls.cityName.setErrors({ incorrect: true });
      this.invalidLocation = true;
      this.selectedCountry = '';
      this.mapAnswer('Taker_Address_Place', null);
    }
  }

  onSelectionChange(choice, event) {
    this.invalidLocation = false;
    this.mapAnswer('Taker_Address_Place', event);
    const contryName = this.postalForm.get('countryName').value;
    if (contryName === 'BELGIQUE' && contryName === 'BELGIE' && contryName === 'BELGIEN'){
    this.validateInput(event);}

  }

  isNumber(evt, code) {
    if (code === 0) {
      evt = (evt) ? evt : window.event;
      evt.preventDefault();
    } else {
      evt = (evt) ? evt : window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((code.length > 14) || (charCode > 31 && (charCode < 48 || charCode > 57) && (charCode != 43))) {
        evt.preventDefault();
      } else if (charCode === 107) {
        return true;
      } else {
        return true;
      }
    }
  }
  generateErrorMessages(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(controlName => {
      let control = formGroup.controls[controlName];
      let errors = control.errors;
      if (errors === null || errors.count === 0) {
        return;
      }
      // Handle the 'required' case
      if (errors.required) {
        this.errors.push(`${controlName} is required`);
      }
      // Handle 'minlength' case
      if (errors.minlength) {
        this.errors.push(`${controlName} minimum length is ${errors.minlength.requiredLength}.`);
      }
    });
  }
  test() {
    // console.log(this.signForm);
  }
  //#endregion
}
